<ion-content class="m-modal">
  <ion-grid class="ion-padding">
    <ion-row class="m-modal-header">
      <ion-col size="12" size-md="11">
        <h4 class="m-modal-title">{{ modalTitle }}</h4>
      </ion-col>
      <ion-col size="6" size-md="1" class="ion-text-center">
        <ion-button color="tech-blue" class="m-modal-icon" fill="clear" (click)="dismiss()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="m-modal-body">
      <ion-col size="12">
        <ion-list class="m-modal-field-list list-color-custom">
          <p class="insights-full" [innerHTML]="resumeDetail"></p>

          @if (tableFinanceDetail.length > 0) {
          <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30">
            <ion-grid class="ion-no-padding">
              <ion-row class="ion-align-items-center">
                <ion-col size="auto">
                  <span class="message-section-bubble-box finance-bubble">
                    <ion-icon slot="start" [src]="'/assets/imgs/icons/money-chat-outline.svg'"
                      class="icon-color-custom-svg ion-icon-svg-chat-center">
                    </ion-icon>
                    Financial
                  </span>
                </ion-col>
                <ion-col size="auto">
                  <!-- <h2 class="chat-modal-title-section finance-title">Datos financieros</h2> -->
                </ion-col>
              </ion-row>
            </ion-grid>

            <p class="table-container" [innerHTML]="tableFinanceDetail"></p>
          </div>
          }

          @if (tableOperationsDetail.length > 0) {
          <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30">

            <ion-grid class="ion-no-padding">
              <ion-row class="ion-align-items-center">
                <ion-col size="auto">
                  <span class="message-section-bubble-box operations-bubble">
                      <ion-icon slot="start" [src]="'/assets/imgs/icons/truck-chat-outline.svg'"
                        class="icon-color-custom-svg ion-icon-svg-chat-center">
                      </ion-icon>
                      Operations
                    </span>
                </ion-col>
                <ion-col size="auto">
                  <!-- <h2 class="chat-modal-title-section operations-title">Datos operativos</h2> -->
                </ion-col>
              </ion-row>
            </ion-grid>


            <p class="table-container" [innerHTML]="tableOperationsDetail"></p>
          </div>
          }

          @if (tableDetail.length > 0) {
          <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30">
            <h2 class="chat-modal-title-section">📊 Tabla de Datos</h2>

            <p class="table-container" [innerHTML]="tableDetail"></p>
          </div>
          }

          @if (chartsDetail.length > 0 || chartDetail.length > 0) {
          <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30 ion-text-center">
            <h2 class="chat-modal-title-section">📈 Gráfico</h2>

            @if (chartsDetail.length > 0) {
            <div class="ion-padding-start-8 ion-padding-end-8">
              <div class="chart-container">
                <ion-grid class="ion-no-padding">
                  <ion-row class="ion-justify-content-center">
                    <ion-col size="12" class="ion-padding-5">
                      <swiper-container #chartsCarousel init="false" class="mySwiper ion-over-visible-content">
                        @for (chart of chartsDetail; track chart; let idx = $index) {
                        <swiper-slide>
                          <img [src]="chart" class="maximixed-img-chart-ai box-clickable"
                            (click)="onOpenImageSwiperModal(idx)" />
                        </swiper-slide>
                        }
                      </swiper-container>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </div>
            } @else {
            @if (chartDetail.length > 0) {
            <div class="ion-padding-start-8 ion-padding-end-8">
              <div class="chart-container">
                <ion-grid class="ion-no-padding">
                  <ion-row class="ion-justify-content-center">
                    <ion-col size="12" class="ion-padding-5">
                      <img [src]="chartDetail" class="custom-chart-img box-clickable"
                        (click)="onOpenImageViewerModal(chartDetail)" alt="Gráfico" />
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </div>
            }
            }
          </div>
          }
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>